import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { AddFontButtonComponent } from './add-font-button.component';


@NgModule({
  declarations: [
    AddFontButtonComponent
  ],
  exports: [
    AddFontButtonComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ],
})
export class AddFontButtonModule { }
